import React, { useState } from "react";
import { signIn } from "../../functions/auth";
import { useNavigate } from "react-router-dom";
import ForgottenPasswordModal from "../../pages/ForgottenPasswordModal";

function LoginComponent() {

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();
    const [isForgottenPasswordModalVisible, setForgottenPasswordModalVisible] = useState(false);

    const handleLogin = (e) => {
        e.preventDefault();
        signIn(email, password);
        navigate("/dashboard");
    }

    const toggleForgottenPasswordModal = () => {
        setForgottenPasswordModalVisible(!isForgottenPasswordModalVisible);
    }

    return (
        <div className="flex items-center justify-center">
            {isForgottenPasswordModalVisible && <ForgottenPasswordModal onClose={toggleForgottenPasswordModal} />}
            <div className="bg-white p-8 rounded-md max-w-xl w-full">
                <h2 className="text-2xl font-bold mb-4 text-center">Login</h2>
                <div>
                    <form className="flex flex-col gap-4" onSubmit={handleLogin}>
                        <input 
                            type="text" 
                            placeholder="Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="p-2 border border-gray-300 rounded"
                        />
                        <input 
                            type="password" 
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="p-2 border border-gray-300 rounded"
                        />
                        <button 
                            type="submit"
                            className="bg-teal-500 hover:bg-teal-600 text-white font-bold py-2 px-4 rounded mt-4"
                        >
                            Login
                        </button>
                        <div className="mt-4 text-center">
                            <span 
                                className="text-blue-500 hover:text-blue-700 cursor-pointer"
                                onClick={toggleForgottenPasswordModal}
                            >
                                Forgotten Password?
                            </span>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default LoginComponent;
